var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C13.6046 14 14.5 13.1046 14.5 12C14.5 10.8954 13.6046 10 12.5 10C11.3954 10 10.5 10.8954 10.5 12C10.5 13.1046 11.3954 14 12.5 14Z",
    stroke: "#F0514E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7418 7.75969C17.2996 8.31693 17.7422 8.97866 18.0441 9.70705C18.3461 10.4354 18.5015 11.2162 18.5015 12.0047C18.5015 12.7932 18.3461 13.5739 18.0441 14.3023C17.7422 15.0307 17.2996 15.6924 16.7418 16.2497M8.26177 16.2397C7.70391 15.6824 7.26136 15.0207 6.95941 14.2923C6.65747 13.5639 6.50205 12.7832 6.50205 11.9947C6.50205 11.2062 6.65747 10.4254 6.95941 9.69705C7.26136 8.96866 7.70391 8.30693 8.26177 7.74969M19.5718 4.92969C21.4465 6.80496 22.4996 9.34805 22.4996 11.9997C22.4996 14.6513 21.4465 17.1944 19.5718 19.0697M5.43177 19.0697C3.55706 17.1944 2.50391 14.6513 2.50391 11.9997C2.50391 9.34805 3.55706 6.80496 5.43177 4.92969",
    stroke: "#F0514E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.2e533818455ab4b37b99f81f3a9c16f6.svg";
export { ForwardRef as ReactComponent };